import $ from 'jquery';

export class MainMenu {
    public static init(): void {
        const mainMenus = document.querySelectorAll('.main-menu');
        for (const mainMenu of Array.from(mainMenus)) {
            const hovers = $(mainMenu).find('> .dropdown-hover');

            for (const hover of Array.from(hovers)) {
                const dropdown = $(hover).find('> .dropdown-nav-menu');

                if (dropdown.length === 0) continue;

                hover.addEventListener('click', (e) => {
                    if (dropdown.css('display') === 'flex') {
                        dropdown.css('display', 'none');
                    } else {
                        dropdown.css('display', 'flex');
                    }
                });
            }
        }
        MainMenu._menuMobile();
        MainMenu._megaMenu();
    }

    public static _menuMobile(): void {
        const open_menu = $('header').find('.navbar-toggler');
        const header_left = $('header').find('.header_left');
        const close_menu = header_left.find('.close-menu');

        function toggleItem(item: JQuery) {
            item.toggleClass('rotate');
            item.siblings('.menu').toggle(200, () => item.toggleClass('item-expanded'));
        }

        open_menu.on("click", function () {
            header_left.addClass("visible");
        });

        close_menu.on("click", function () {
            header_left.removeClass("visible");

            const itemsExpanded = header_left.find('.item-expanded');
            itemsExpanded.each(function () {
                toggleItem($(this));
            });
        });

        const menu = $('.header_left #block-menuprincipalizquierda');
        const expandedItems = menu.find('.menu-item--expanded');

        const expand = '<span class="expanded"></span>';

        expandedItems.each(function () {
            $(this).append(expand);
        });

        menu.on('click', '.nav .menu-item--expanded > .expanded', function (e: JQuery.ClickEvent) {
            e.preventDefault();
            e.stopPropagation();
            toggleItem($(this));
        })

        menu.on('click', '.nav-item', function (e: JQuery.ClickEvent) {
            e.stopPropagation();
        });

        $('.navbar-toggler-icon').on('click', function () {
            $('body').css('overflow-y', 'hidden');
        });

        $('.close-menu').on('click', function () {
            $('body').css('overflow-y', 'auto');
        });
    }

    public static _megaMenu(): void {
        const menuCompany = $('.block-tb-megamenu .menu-company');
        const list = menuCompany.find('> .tb-megamenu-column-inner > ul.tb-megamenu-subnav.level-1');
        const items = list.find('> li').not(':first-child');

        const container = $('<div class="column-rest-company"></div>');
        container.append(items);
        list.append(container);
    }
}
